import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { environment } from '@environment';
import { FirebaseAnalyticsService } from '@shared/services/firebase';

import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TitleResolver implements Resolve<string> {
    constructor(
        private titleService: Title,
        private firebaseAnalyticsService: FirebaseAnalyticsService,
    ) {}
    resolve(route: ActivatedRouteSnapshot): Observable<string> | Promise<string> | string {
        this.checkResolveData(route);
        return '';
    }

    private checkResolveData(route: ActivatedRouteSnapshot) {
        let title;
        let pageView;
        const routeData = route?.data as any;
        pageView = routeData?.pageView;
        title = routeData?.title ?? environment.configApp.nome;

        this.titleService.setTitle(`${title}`);
        this.firebaseAnalyticsService.setCurrentScreen(pageView);
    }
}
